import {
  type PolylineHighlightSection,
  PolylineHighlightSectionIcon,
  PolylineHighlightSectionType
} from '@strava/mre';

export const getHighlightSectionFromIndices = (
  start: number,
  end: number,
  type?: PolylineHighlightSectionType,
  icon?: PolylineHighlightSectionIcon
): PolylineHighlightSection | null => {
  if (typeof start !== 'number' || typeof end !== 'number') {
    throw new Error('Start and end indices must be provided');
  }

  if (start < 0 || end < 0 || end < start) {
    throw new Error('Invalid start or end indices');
  }

  // If start and end are the same, there's no section to highlight.
  if (end === start) {
    return null;
  }

  return {
    identifier: `highlight-section-${start}-${end}`,
    startIndex: BigInt(start),
    endIndex: BigInt(end),
    type: type ?? PolylineHighlightSectionType.BLUE, // Default type to BLUE if no type provided.
    icon // Optional
  };
};
